import React, { useState, useEffect } from 'react';
import SupplierAddItem from './SupplierAddItem';
import SupplierList from './SupplierList';
import { useMode } from '../contexts/ModeContext';
import { Modal, Button } from 'react-bootstrap';

const Suppliers = ({isSubtitle}) => {
    const [refreshList, setRefreshList] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const { isModeAdmin } = useMode();

    const handleAddItem = () => {
        setRefreshList(!refreshList);
        setShowModal(false);
    };

    useEffect(() => {
        setRefreshList(false);
    }, [isModeAdmin]);

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <>
            <SupplierList refreshList={refreshList} isSubtitle={isSubtitle} />
            { isModeAdmin && (
                <>
                    <Button variant="primary" onClick={() => setShowModal(true)} style={{margin:'0 20px 20px 20px'}}>Ajouter un fournisseur</Button>
                    <Modal show={showModal} onHide={handleCloseModal} size='xl'>
                        <Modal.Header closeButton>
                            <Modal.Title>Ajouter un fournisseur</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <SupplierAddItem handleAddItem={handleAddItem} />
                        </Modal.Body>
                    </Modal>
                </>
            )}
        </>
    );
}

export default Suppliers;
